import React, { useState, useEffect } from "react";
import style from "./NewPlatformStyle";
import { createEnterprise } from "../../../Services/enterpriseService";
import { getAllSubscriptionTypes } from "../../../Services/subscriptionService"; // Importando o serviço de assinatura
import axios from "axios";

export default function NewPlatform({ onFinish }) {
  const initialState = {
    enterpriseName: "",
    cnpj: "",
    contact: "",
    email: "",
    adminName: "",
    adminLoginId: "",
    adminPassword: "",
    metaAccountId: "",
    whatsappToken: "",
    agentName: "",
    agentNumber: "",
    headerText: "",
    bodyText: "",
    subscriptionTypeId: "", // <-- Campo para o ID do plano
    address: {
      street: "",
      number: "",
      neighborhood: "",
      city: "",
      state: "",
      country: "Brasil",
      zipcode: "",
    },
  };

  const [formData, setFormData] = useState(initialState);
  const [subscriptionTypes, setSubscriptionTypes] = useState([]);
  const [loadingTypes, setLoadingTypes] = useState(true);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isCepLoading, setIsCepLoading] = useState(false);

  // Hook para buscar os tipos de assinatura quando o componente for montado
  useEffect(() => {
    const fetchSubscriptionTypes = async () => {
      try {
        const types = await getAllSubscriptionTypes();
        setSubscriptionTypes(types);
      } catch (err) {
        console.error("Falha ao buscar planos de assinatura", err);
        setError("Não foi possível carregar os planos de assinatura.");
      } finally {
        setLoadingTypes(false);
      }
    };
    fetchSubscriptionTypes();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const keys = name.split(".");

    if (keys.length > 1) {
      setFormData((prev) => ({
        ...prev,
        [keys[0]]: {
          ...prev[keys[0]],
          [keys[1]]: value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleCepBlur = async (e) => {
    const cep = e.target.value.replace(/\D/g, "");
    if (cep.length !== 8) {
      return;
    }

    setIsCepLoading(true);
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
      const data = response.data;
      if (!data.erro) {
        setFormData((prev) => ({
          ...prev,
          address: {
            ...prev.address,
            zipcode: cep,
            street: data.logradouro || "",
            neighborhood: data.bairro || "",
            city: data.localidade || "",
            state: data.uf || "",
            country: "Brasil",
          },
        }));
      }
    } catch (error) {
      console.warn("Não foi possível buscar o CEP.", error);
    } finally {
      setIsCepLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validação para garantir que um plano foi selecionado
    if (!formData.subscriptionTypeId) {
      setError("Por favor, selecione um plano de assinatura.");
      return;
    }
    setLoading(true);
    setError("");

    const success = await createEnterprise(formData);

    if (success) {
      alert("Cliente criado com sucesso!");
      onFinish();
    } else {
      setError(
        "Não foi possível criar o cliente. Verifique os dados e tente novamente."
      );
    }
    setLoading(false);
  };

  return (
    <div style={style.container}>
      <header style={style.header}>
        <h1 style={style.title}>Cadastrar Novo Cliente</h1>
        <p style={style.subtitle}>
          Preencha todos os dados para a criação completa da plataforma.
        </p>
      </header>

      <form onSubmit={handleSubmit} style={style.form}>
        {/* === PLANO DE ASSINATURA === */}
        <div style={style.formSection}>
          <h2 style={style.sectionTitle}>Plano de Assinatura</h2>
          <div style={style.inputGroup}>
            <label htmlFor="subscriptionTypeId" style={style.label}>
              Plano
            </label>
            <select
              id="subscriptionTypeId"
              name="subscriptionTypeId"
              value={formData.subscriptionTypeId}
              onChange={handleChange}
              style={style.input}
              required
              disabled={loadingTypes}
            >
              <option value="" disabled>
                {loadingTypes ? "Carregando planos..." : "Selecione um plano"}
              </option>
              {subscriptionTypes.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.name} - R$ {type.value.toFixed(2)}/mês
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* === DADOS DA EMPRESA === */}
        <div style={style.formSection}>
          <h2 style={style.sectionTitle}>Dados da Empresa</h2>
          <div style={style.inputGrid2Cols}>
            <div style={style.inputGroup}>
              <label htmlFor="enterpriseName" style={style.label}>
                Nome da Empresa
              </label>
              <input
                type="text"
                id="enterpriseName"
                name="enterpriseName"
                value={formData.enterpriseName}
                onChange={handleChange}
                style={style.input}
                required
              />
            </div>
            <div style={style.inputGroup}>
              <label htmlFor="cnpj" style={style.label}>
                CNPJ
              </label>
              <input
                type="text"
                id="cnpj"
                name="cnpj"
                value={formData.cnpj}
                onChange={handleChange}
                style={style.input}
                required
              />
            </div>
          </div>
          <div style={style.inputGrid2Cols}>
            <div style={style.inputGroup}>
              <label htmlFor="contact" style={style.label}>
                Contato (WhatsApp)
              </label>
              <input
                type="tel"
                id="contact"
                name="contact"
                value={formData.contact}
                onChange={handleChange}
                style={style.input}
                required
              />
            </div>
            <div style={style.inputGroup}>
              <label htmlFor="email" style={style.label}>
                E-mail Principal
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                style={style.input}
                required
              />
            </div>
          </div>
        </div>

        {/* === ENDEREÇO === */}
        <div style={style.formSection}>
          <h2 style={style.sectionTitle}>Endereço</h2>
          <div style={style.inputGrid2Cols}>
            <div style={style.inputGroup}>
              <label htmlFor="zipcode" style={style.label}>
                CEP
              </label>
              <input
                type="text"
                id="zipcode"
                name="address.zipcode"
                value={formData.address.zipcode}
                onChange={handleChange}
                onBlur={handleCepBlur}
                style={style.input}
                required
              />
            </div>
            <div style={style.inputGroup}>
              <label htmlFor="number" style={style.label}>
                Número
              </label>
              <input
                type="text"
                id="number"
                name="address.number"
                value={formData.address.number}
                onChange={handleChange}
                style={style.input}
                required
              />
            </div>
          </div>
          <div style={style.inputGroup}>
            <label htmlFor="street" style={style.label}>
              Rua / Logradouro
            </label>
            <input
              type="text"
              id="street"
              name="address.street"
              value={isCepLoading ? "Carregando..." : formData.address.street}
              onChange={handleChange}
              style={{
                ...style.input,
                ...(isCepLoading ? style.inputLoading : {}),
              }}
              disabled={isCepLoading}
              required
            />
          </div>
          <div style={style.inputGrid3Cols}>
            <div style={style.inputGroup}>
              <label htmlFor="neighborhood" style={style.label}>
                Bairro
              </label>
              <input
                type="text"
                id="neighborhood"
                name="address.neighborhood"
                value={
                  isCepLoading ? "Carregando..." : formData.address.neighborhood
                }
                onChange={handleChange}
                style={{
                  ...style.input,
                  ...(isCepLoading ? style.inputLoading : {}),
                }}
                disabled={isCepLoading}
                required
              />
            </div>
            <div style={style.inputGroup}>
              <label htmlFor="city" style={style.label}>
                Cidade
              </label>
              <input
                type="text"
                id="city"
                name="address.city"
                value={isCepLoading ? "Carregando..." : formData.address.city}
                onChange={handleChange}
                style={{
                  ...style.input,
                  ...(isCepLoading ? style.inputLoading : {}),
                }}
                disabled={isCepLoading}
                required
              />
            </div>
            <div style={style.inputGroup}>
              <label htmlFor="state" style={style.label}>
                Estado
              </label>
              <input
                type="text"
                id="state"
                name="address.state"
                value={isCepLoading ? "Carregando..." : formData.address.state}
                onChange={handleChange}
                style={{
                  ...style.input,
                  ...(isCepLoading ? style.inputLoading : {}),
                }}
                disabled={isCepLoading}
                required
              />
            </div>
          </div>
        </div>

        {/* === CREDENCIAIS DA META === */}
        <div style={style.formSection}>
          <h2 style={style.sectionTitle}>Credenciais da Meta</h2>
          <div style={style.inputGrid2Cols}>
            <div style={style.inputGroup}>
              <label htmlFor="whatsappToken" style={style.label}>
                WhatsApp Token
              </label>
              <input
                type="text"
                id="whatsappToken"
                name="whatsappToken"
                value={formData.whatsappToken}
                onChange={handleChange}
                style={style.input}
                placeholder="EAA..."
                required
              />
            </div>
            <div style={style.inputGroup}>
              <label htmlFor="metaAccountId" style={style.label}>
                Meta Account ID
              </label>
              <input
                type="text"
                id="metaAccountId"
                name="metaAccountId"
                value={formData.metaAccountId}
                onChange={handleChange}
                style={style.input}
                required
              />
            </div>
          </div>
        </div>

        {/* === AGENTE PRINCIPAL === */}
        <div style={style.formSection}>
          <h2 style={style.sectionTitle}>Agente Principal</h2>
          <div style={style.inputGrid2Cols}>
            <div style={style.inputGroup}>
              <label htmlFor="agentName" style={style.label}>
                Nome do Agente
              </label>
              <input
                type="text"
                id="agentName"
                name="agentName"
                value={formData.agentName}
                onChange={handleChange}
                style={style.input}
                required
              />
            </div>
            <div style={style.inputGroup}>
              <label htmlFor="agentNumber" style={style.label}>
                Número/ID do Agente
              </label>
              <input
                type="text"
                id="agentNumber"
                name="agentNumber"
                value={formData.agentNumber}
                onChange={handleChange}
                style={style.input}
                placeholder="Ex: 5511... (número real)"
                required
              />
            </div>
          </div>
        </div>

        {/* === TEMPLATE DE REMARKETING === */}
        <div style={style.formSection}>
          <h2 style={style.sectionTitle}>Template de Remarketing Padrão</h2>
          <div style={style.inputGroup}>
            <label htmlFor="headerText" style={style.label}>
              Texto do Cabeçalho (Header)
            </label>
            <input
              type="text"
              id="headerText"
              name="headerText"
              value={formData.headerText}
              onChange={handleChange}
              style={style.input}
              placeholder="Ex: Olá, tudo bem?"
              required
            />
          </div>
          <div style={style.inputGroup}>
            <label htmlFor="bodyText" style={style.label}>
              Texto Principal (Body)
            </label>
            <textarea
              id="bodyText"
              name="bodyText"
              value={formData.bodyText}
              onChange={handleChange}
              style={style.textarea}
              placeholder="Ex: Vi que você demonstrou interesse em nosso produto..."
              required
            />
          </div>
        </div>

        {/* === ADMINISTRADOR PRINCIPAL === */}
        <div style={style.formSection}>
          <h2 style={style.sectionTitle}>Administrador Principal</h2>
          <div style={style.inputGroup}>
            <label htmlFor="adminName" style={style.label}>
              Nome do Administrador
            </label>
            <input
              type="text"
              id="adminName"
              name="adminName"
              value={formData.adminName}
              onChange={handleChange}
              style={style.input}
              required
            />
          </div>
          <div style={style.inputGrid2Cols}>
            <div style={style.inputGroup}>
              <label htmlFor="adminLoginId" style={style.label}>
                Usuário de Acesso
              </label>
              <input
                type="text"
                id="adminLoginId"
                name="adminLoginId"
                value={formData.adminLoginId}
                onChange={handleChange}
                style={style.input}
                required
              />
            </div>
            <div style={style.inputGroup}>
              <label htmlFor="adminPassword" style={style.label}>
                Senha
              </label>
              <input
                type="password"
                id="adminPassword"
                name="adminPassword"
                value={formData.adminPassword}
                onChange={handleChange}
                style={style.input}
                required
              />
            </div>
          </div>
        </div>

        {error && (
          <p style={{ color: "#F87171", textAlign: "center" }}>{error}</p>
        )}

        <div style={style.buttonContainer}>
          <button
            type="button"
            style={style.cancelButton}
            onClick={onFinish}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            type="submit"
            style={style.submitButton}
            disabled={loading || isCepLoading || loadingTypes}
          >
            {loading ? "Salvando..." : "Salvar Cliente"}
          </button>
        </div>
      </form>
    </div>
  );
}
